/**
 * Trustoo Reviews Layout Helper - Yafa Beauty
 * Organização do card:
 * 1. Foto do cliente (ou fallback) no topo fora do card
 * 2. Card unificado (.yafa-review-card):
 *    - Nome e Selo Verificado
 *    - Estrelas (imediatamente abaixo do nome)
 *    - Linha divisória 1 (#EDEDED)
 *    - Título e Texto da avaliação
 *    - Linha divisória 2 (#EDEDED)
 *    - Cardzinho do Produto (estilo Carrossel-avaliativo-vzk)
 */
(function () {
  'use strict';

  var isOrganizing = false;

  // Obtém a nota (1 a 5 estrelas) que o usuário deu na avaliação
  function getReviewRating(review) {
    if (!review) return 5;

    // 1. Tenta pegar de data-score, data-rating, data-star no review ou elementos internos
    var scoreAttr =
      review.getAttribute('data-score') ||
      review.getAttribute('data-rating') ||
      review.getAttribute('data-star') ||
      review.getAttribute('data-rate');

    if (scoreAttr && !isNaN(parseFloat(scoreAttr))) {
      var s = Math.round(parseFloat(scoreAttr));
      if (s >= 1 && s <= 5) return s;
    }

    var scoreEl = review.querySelector('[data-score], [data-rating], [data-star], [data-rate], [data-stars]');
    if (scoreEl) {
      var val =
        scoreEl.getAttribute('data-score') ||
        scoreEl.getAttribute('data-rating') ||
        scoreEl.getAttribute('data-star') ||
        scoreEl.getAttribute('data-rate') ||
        scoreEl.getAttribute('data-stars');
      if (val && !isNaN(parseFloat(val))) {
        var s2 = Math.round(parseFloat(val));
        if (s2 >= 1 && s2 <= 5) return s2;
      }
    }

    // 2. Procura em classes como score-5, star-5, rating-5
    var classMatch = (review.className || '').match(/(?:score|star|rating)-([1-5])/i);
    if (classMatch) return parseInt(classMatch[1], 10);

    // 3. Procura no elemento vstar-star nativo do Trustoo
    var vstar = review.querySelector('.vstar-star');
    if (vstar) {
      var vstarScore =
        vstar.getAttribute('data-score') ||
        vstar.getAttribute('data-rating') ||
        vstar.getAttribute('data-star');
      if (vstarScore && !isNaN(parseFloat(vstarScore))) {
        var s3 = Math.round(parseFloat(vstarScore));
        if (s3 >= 1 && s3 <= 5) return s3;
      }
      var vClassMatch = (vstar.className || '').match(/(?:score|star|rating)-([1-5])/i);
      if (vClassMatch) return parseInt(vClassMatch[1], 10);

      // Conta quantas estrelas não estão vazias/uncheck
      var svgs = vstar.querySelectorAll('svg, .star-item');
      if (svgs.length > 0) {
        var count = 0;
        for (var i = 0; i < svgs.length; i++) {
          var item = svgs[i];
          var cls = (item.getAttribute('class') || '') + ' ' + (item.parentElement ? item.parentElement.getAttribute('class') || '' : '');
          if (!/empty|uncheck|unstar|gray|grey|inactive/i.test(cls)) {
            count++;
          }
        }
        if (count >= 1 && count <= 5) return count;
      }
    }

    // 4. Default de segurança: 5 estrelas
    return 5;
  }

  // Constrói as estrelas da avaliação de forma infalível e com visual idêntico à loja
  function buildStarsRow(review) {
    if (!review) return null;

    var score = getReviewRating(review);

    var existingRow = review.querySelector('.yafa-review-card .yafa-stars-row');
    var row = existingRow || document.createElement('div');
    row.className = 'yafa-stars-row';
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', score + ' de 5 estrelas');

    // 5 estrelas vetoriais nítidas (Pretas para a nota recebida, Cinza para vazias)
    var starSvgFilled =
      '<svg class="yafa-star-icon" width="14" height="14" viewBox="0 0 20 19" fill="#000000" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M10 0.5L12.9389 6.45524L19.5106 7.41016L14.7553 12.0448L15.8779 18.5898L10 15.5L4.12215 18.5898L5.24472 12.0448L0.489435 7.41016L7.06107 6.45524L10 0.5Z" fill="#000000"/>' +
      '</svg>';

    var starSvgEmpty =
      '<svg class="yafa-star-icon is-empty" width="14" height="14" viewBox="0 0 20 19" fill="#EDEDED" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M10 0.5L12.9389 6.45524L19.5106 7.41016L14.7553 12.0448L15.8779 18.5898L10 15.5L4.12215 18.5898L5.24472 12.0448L0.489435 7.41016L7.06107 6.45524L10 0.5Z" fill="#EDEDED"/>' +
      '</svg>';

    var starsHtml = '';
    for (var i = 0; i < 5; i++) {
      starsHtml += (i < score) ? starSvgFilled : starSvgEmpty;
    }
    row.innerHTML = starsHtml;

    // Se houver um .vstar-star nativo fora da linha, oculta para não duplicar
    var nativeVstar = review.querySelector('.vstar-star');
    if (nativeVstar && nativeVstar.parentElement && !row.contains(nativeVstar)) {
      nativeVstar.style.display = 'none';
    }

    return row;
  }

  // Formata o cardzinho do produto exatamente no estilo de Carrossel-avaliativo-vzk.liquid
  function formatProductCard(rawProduct, review) {
    var product = rawProduct;
    var img = product ? product.querySelector('img') : null;

    var productType = '';
    var productTitle = '';

    if (product) {
      var typeEl = product.querySelector('.product-type, .product-tag');
      var titleEl = product.querySelector('.product-title, .product-name');

      productType = typeEl ? typeEl.textContent.trim() : '';
      productTitle = titleEl ? titleEl.textContent.trim() : '';

      if (!productTitle && !productType) {
        var rawText = product.textContent.trim();
        if (rawText.indexOf(' - ') !== -1) {
          var p1 = rawText.split(' - ');
          productType = p1[0].trim();
          productTitle = p1.slice(1).join(' - ').trim();
        } else if (rawText.indexOf(' – ') !== -1) {
          var p2 = rawText.split(' – ');
          productType = p2[0].trim();
          productTitle = p2.slice(1).join(' – ').trim();
        } else if (rawText.indexOf(' — ') !== -1) {
          var p3 = rawText.split(' — ');
          productType = p3[0].trim();
          productTitle = p3.slice(1).join(' — ').trim();
        } else if (rawText.indexOf('-') !== -1) {
          var p4 = rawText.split('-');
          productType = p4[0].trim();
          productTitle = p4.slice(1).join('-').trim();
        } else {
          productTitle = rawText;
        }
      }
    }

    // Fallbacks a partir da página atual se faltar imagem ou título
    var pageTitle = '';
    var pageSubtitle = '';
    var pageImg = '';

    var pageTitleEl = document.querySelector('.product__title-text') || document.querySelector('.product__title h1');
    if (pageTitleEl) pageTitle = pageTitleEl.textContent.trim();
    if (!pageTitle && document.title) {
      pageTitle = document.title.split('–')[0].split('-')[0].trim();
    }

    var pageSubEl = document.querySelector('.product__title--subtitle');
    if (pageSubEl) pageSubtitle = pageSubEl.textContent.trim();

    var pageImgEl = document.querySelector('.product__media-wrapper img, .product__media img');
    if (pageImgEl) pageImg = pageImgEl.getAttribute('src') || pageImgEl.src;

    if (!productTitle && pageTitle) {
      productTitle = pageTitle;
    }
    if (!productType && pageSubtitle) {
      productType = pageSubtitle;
    }

    if (!product) {
      product = document.createElement('a');
      product.href = window.location.pathname;
    }

    // Estrutura idêntica à de Carrossel-avaliativo-vzk.liquid
    product.className = 'yafa-evaluative__product related-product';
    product.innerHTML = '';

    var finalImg = img;
    if (!finalImg && pageImg) {
      finalImg = document.createElement('img');
      finalImg.src = pageImg;
      finalImg.alt = productTitle || 'Produto';
    }

    if (finalImg) {
      finalImg.className = 'yafa-evaluative__product-image has-background';
      product.appendChild(finalImg);
    }

    var copySpan = document.createElement('span');
    copySpan.className = 'yafa-evaluative__product-copy';

    if (productType) {
      var typeSpan = document.createElement('span');
      typeSpan.className = 'yafa-evaluative__product-type';
      typeSpan.textContent = productType.toUpperCase();
      copySpan.appendChild(typeSpan);
    }

    var titleSpan = document.createElement('span');
    titleSpan.className = 'yafa-evaluative__product-title';
    titleSpan.textContent = (productTitle || 'PRODUTO').toUpperCase();
    copySpan.appendChild(titleSpan);

    product.appendChild(copySpan);
    return product;
  }

  function organizeReview(review) {
    if (!review) return;

    // Se o card já está perfeitamente montado com as estrelas (com pelo menos 5 SVGs) e o cardzinho, não repete
    var existingCard = review.querySelector('.yafa-review-card');
    var existingStars = existingCard ? existingCard.querySelector('.yafa-stars-row') : null;
    var hasValidStars = existingStars && existingStars.querySelectorAll('svg').length >= 5;
    var hasProductCard = existingCard && existingCard.querySelector('.yafa-evaluative__product');

    if (review.dataset.yafaDone === 'true' && existingCard && hasValidStars && hasProductCard) {
      var rList = review.querySelector('.resource-list');
      if (rList) {
        rList.style.margin = '0px';
        rList.style.marginBottom = '0px';
        if (rList.nextElementSibling !== existingCard) {
          rList.after(existingCard);
        }
      }
      existingCard.style.margin = '0px';
      existingCard.style.marginTop = '0px';
      return;
    }

    // 1. Foto do cliente (ou fallback) no topo fora do card
    var resourceList = review.querySelector('.resource-list');
    var firstImg = resourceList ? resourceList.querySelector('img') : null;

    if (!firstImg) {
      var prodImg = review.querySelector('.related-product img') ||
                    document.querySelector('.product__media-wrapper img, .product__media img');
      if (prodImg && !resourceList) {
        resourceList = document.createElement('div');
        resourceList.className = 'resource-list yafa-fallback-photo';
        var item = document.createElement('div');
        item.className = 'resource-item';
        var clone = prodImg.cloneNode(true);
        item.appendChild(clone);
        resourceList.appendChild(item);
      }
    }

    if (resourceList && review.firstElementChild !== resourceList) {
      review.insertBefore(resourceList, review.firstElementChild);
    }

    // 2. Card unificado (.yafa-review-card)
    var card = existingCard;
    if (!card) {
      card = document.createElement('div');
      card.className = 'yafa-review-card';
    }

    // Remove qualquer container legado de data ou linha vazia inserida incorretamente
    var oldEmptyRows = card.querySelectorAll('.review-row-one');
    oldEmptyRows.forEach(function (r) {
      if (r.querySelectorAll('svg').length === 0) {
        r.remove();
      }
    });

    // 3. Localiza os elementos
    var userMessage =
      review.querySelector('.user-message') ||
      (review.querySelector('.author-name') ? review.querySelector('.author-name').closest('.user-message') : null) ||
      review.querySelector('.author-name');

    // Constrói ou atualiza a linha com as estrelas que o cliente deu
    var stars = buildStarsRow(review);

    var title = review.querySelector('.tt-review-title') || review.querySelector('.review-title');
    var text =
      review.querySelector('.reviews-text') ||
      review.querySelector('.display-text') ||
      review.querySelector('.remain-text');

    var rawProduct = review.querySelector('.related-product');
    var productCard = formatProductCard(rawProduct, review);

    var divider2 = card.querySelector('.yafa-review-divider-bottom');
    if (!divider2) {
      divider2 = document.createElement('div');
      divider2.className = 'yafa-review-divider-bottom';
    }

    // Remove qualquer divisória duplicada para manter rigorosamente uma única linha
    var allDividers = card.querySelectorAll('.yafa-review-divider-bottom');
    if (allDividers.length > 1) {
      for (var d = 1; d < allDividers.length; d++) {
        allDividers[d].remove();
      }
    }

    // 4. Monta dentro do card na ordem exata solicitada:
    // 1º Nome e Selo Verificado (sempre no topo absoluto do card, sem linha em cima)
    if (userMessage) {
      if (card.firstElementChild !== userMessage) {
        card.insertBefore(userMessage, card.firstElementChild);
      }
    }

    // 2º Estrelas que o usuário deu (imediatamente abaixo do nome)
    if (stars && userMessage) {
      userMessage.after(stars);
    } else if (stars) {
      card.appendChild(stars);
    }

    // 3º Título da escrita
    var lastNode = stars || userMessage;
    if (title) {
      if (lastNode) {
        lastNode.after(title);
      } else {
        card.appendChild(title);
      }
      lastNode = title;
    }

    // 4º Texto da escrita
    if (text) {
      if (lastNode) {
        lastNode.after(text);
      } else {
        card.appendChild(text);
      }
      lastNode = text;
    }

    // 5º Linha divisória ÚNICA (exclusivamente entre a escrita e o cardzinho do produto)
    if (divider2) {
      if (lastNode) {
        lastNode.after(divider2);
      } else {
        card.appendChild(divider2);
      }
      lastNode = divider2;
    }

    // 6º Cardzinho do produto (estilo Carrossel-avaliativo-vzk)
    if (productCard) {
      if (lastNode) {
        lastNode.after(productCard);
      } else {
        card.appendChild(productCard);
      }
    }

    // 5. Garante que a foto e o card fiquem 100% encostados sem nada entre eles
    if (resourceList) {
      resourceList.style.margin = '0px';
      resourceList.style.marginBottom = '0px';
      if (resourceList.nextElementSibling !== card) {
        resourceList.after(card);
      }
    } else if (card.parentElement !== review) {
      review.appendChild(card);
    }
    card.style.margin = '0px';
    card.style.marginTop = '0px';

    // 6. Oculta containers legados vazios
    var legacyContainers = review.querySelectorAll(
      '.grid-review-head, .list-review-head, .review-head, .grid-review-body, .list-review-body, .review-body'
    );
    legacyContainers.forEach(function (c) {
      if (c !== card) {
        c.style.display = 'none';
      }
    });

    review.dataset.yafaDone = 'true';
  }

  function organizeHeader(widget) {
    if (!widget) return;
    var reviewsHead = widget.querySelector('#reviews-head, .tt-reviews-head');
    if (!reviewsHead) return;

    // 1. Título institucional no topo (O QUE ESTÃO DIZENDO / AVALIAÇÕES)
    var existingTitle = reviewsHead.querySelector('.yafa-reviews-header-title');
    if (!existingTitle) {
      var titleContainer = document.createElement('div');
      titleContainer.className = 'yafa-reviews-header-title';
      titleContainer.innerHTML =
        '<div class="yafa-reviews-header-subtitle">' +
          '<svg class="vzk-propeller yafa-reviews-propeller" width="18" height="18" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<g class="vzk-propeller__rotor">' +
              '<path d="M44.6804 15.2079C49.9576 22.3497 40.9712 31.7101 34.3778 26.9464C33.3266 26.1732 34.1079 25.67 34.1671 24.4873C34.4079 20.2845 29.0551 17.3657 25.9229 20.3864C25.1082 21.1821 24.5532 22.075 24.2429 23.0168C24.0307 23.6462 23.2667 23.8618 22.7473 23.438C24.6424 13.7716 38.5269 6.88659 44.6804 15.2079Z" fill="#5A0E8A"/>' +
              '<path d="M14.6973 1.57848C21.8414 -3.67268 31.24 5.31684 26.4816 11.8867C25.7092 12.9342 25.1872 12.1584 24.0182 12.0917C19.8066 11.842 16.8939 17.1779 19.9274 20.3106C20.7266 21.1255 21.6225 21.6815 22.5667 21.9932C23.1979 22.2064 23.4155 22.9693 22.992 23.4869C13.3025 21.5741 6.37323 7.70155 14.6973 1.57848Z" fill="#5A0E8A"/>' +
              '<path d="M1.59188 31.0953C-3.68538 23.9536 5.30102 14.5932 11.8944 19.3568C12.9457 20.13 12.1643 20.6332 12.1051 21.8159C11.8642 26.0187 17.2171 28.9375 20.3493 25.9168C21.164 25.1211 21.7191 24.2282 22.0293 23.2865C22.2416 22.657 23.0055 22.4414 23.525 22.8652C21.6299 32.5315 7.74538 39.4166 1.59188 31.0953Z" fill="#5A0E8A"/>' +
              '<path d="M31.5741 44.7249C24.43 49.9761 15.0314 40.9865 19.7897 34.4167C20.5622 33.3691 21.0842 34.1451 22.2533 34.2117C26.4649 34.4614 29.3775 29.1254 26.344 25.9927C25.5449 25.1779 24.649 24.622 23.7048 24.3102C23.0736 24.097 22.8559 23.334 23.2794 22.8165C32.9689 24.7293 39.8981 38.6018 31.5741 44.7249Z" fill="#5A0E8A"/>' +
            '</g>' +
          '</svg>' +
          '<span>O QUE ESTÃO DIZENDO</span>' +
        '</div>' +
        '<h2 class="yafa-reviews-header-heading">AVALIAÇÕES</h2>';

      var headContent = reviewsHead.querySelector('.tt-head-content, .head-content');
      if (headContent) {
        reviewsHead.insertBefore(titleContainer, headContent);
      } else {
        reviewsHead.prepend(titleContainer);
      }
    }

    var headRight = reviewsHead.querySelector('.tt-head-right, .head-right');
    var btn = reviewsHead.querySelector('.head-button');
    var sort = reviewsHead.querySelector('.head-sort');

    // Em desktop, mantém alinhamento flex; no mobile, deixa o CSS Grid com display: contents atuar
    if (window.innerWidth > 749) {
      if (headRight) {
        headRight.style.display = 'flex';
        headRight.style.flexDirection = 'row';
        headRight.style.alignItems = 'center';
        headRight.style.justifyContent = 'flex-end';
      }
    } else {
      if (headRight) {
        headRight.style.display = '';
      }
    }

    if (btn) {
      btn.style.margin = '0';
      btn.style.alignSelf = 'center';
      btn.style.verticalAlign = 'middle';
    }
    if (sort) {
      sort.style.margin = '0';
      sort.style.alignSelf = 'center';
      sort.style.verticalAlign = 'middle';
    }
  }

  function organizeAll() {
    if (isOrganizing) return;
    isOrganizing = true;

    try {
      var widget =
        document.getElementById('vstar-reviews') ||
        document.querySelector('.trustoo-widget') ||
        document.querySelector('[data-app="trustoo"]');

      if (widget) {
        organizeHeader(widget);

        var reviews = widget.querySelectorAll('.grid-review, .list-review, .review');
        for (var i = 0; i < reviews.length; i++) {
          organizeReview(reviews[i]);
        }
      }
    } finally {
      isOrganizing = false;
    }
  }

  var scheduled = false;
  function scheduleOrganize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      organizeAll();
    });
  }

  // Execuções em eventos DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleOrganize);
  } else {
    scheduleOrganize();
  }

  // Observer inteligente: escuta apenas o widget quando existir
  function initObserver() {
    var widget =
      document.getElementById('vstar-reviews') ||
      document.querySelector('.trustoo-widget') ||
      document.querySelector('[data-app="trustoo"]');

    if (widget) {
      var widgetObserver = new MutationObserver(function () {
        scheduleOrganize();
      });
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
      });
    } else {
      var bodyObserver = new MutationObserver(function (mutations, obs) {
        var w =
          document.getElementById('vstar-reviews') ||
          document.querySelector('.trustoo-widget') ||
          document.querySelector('[data-app="trustoo"]');
        if (w) {
          obs.disconnect();
          scheduleOrganize();
          initObserver();
        }
      });
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  // Intervalo suave de polling durante o carregamento inicial para captar AJAX do Trustoo
  var checkCount = 0;
  var timer = setInterval(function () {
    checkCount++;
    scheduleOrganize();
    if (checkCount > 15) {
      clearInterval(timer);
    }
  }, 400);
  window.addEventListener('resize', function () {
    var widget =
      document.getElementById('vstar-reviews') ||
      document.querySelector('.trustoo-widget') ||
      document.querySelector('[data-app="trustoo"]');
    if (widget) {
      organizeHeader(widget);
    }
  });
})();
